import layout from '@/views/layout/layout.vue'
const agentList = r => require.ensure([], () => r(require('@/views/marketing/agent/list.vue')), 'group-system-agent')

const agentConfig = [
  {
    path: '/marketing/agent',
    name: 'marketing-agent',
    component: layout,
    redirect: '/marketing/agent/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: agentList,
        name: 'marketing-agent-list',
        meta: {
          displayName: '客户管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default agentConfig



// WEBPACK FOOTER //
// ./src/router/marketing/agent.js